import { ComponentsOverrides, Theme } from "@mui/material";

import colors from "@/themes/base/colors";
import typography from "@/themes/base/typography";
import pxToRem from "@/themes/functions/pxToRem";

const { size, fontWeightRegular } = typography;
const { white, grey } = colors;

interface IStepLabel {
  styleOverrides: ComponentsOverrides<Theme>["MuiStepLabel"];
}

const stepLabel: IStepLabel = {
  styleOverrides: {
    label: {
      marginTop: `${pxToRem(8)} !important`,
      fontWeight: fontWeightRegular,
      fontSize: size.xs,
      color: grey![500],
      textTransform: "uppercase",

      "&.Mui-active": {
        fontWeight: `${fontWeightRegular} !important`,
        color: `${white.main} !important`,
      },

      "&.Mui-completed": {
        fontWeight: `${fontWeightRegular} !important`,
        color: `${white.main} !important`,
      },
    },
  },
};

export default stepLabel;
